module.exports = __webpack_public_path__ + "img/step_1_1.73ed8f3d.jpg";